
function PDFPage8Table1(props: any) {
    return (
        <>
            <table className="table table-sm table-bordered table-striped cu-fs-12" width="100%">
                <thead className="cu-bg-green  ">
                    <tr>
                        <th className="fw-600">{props.TranslateString("Asuin- ja liikehuoneistot X kpl")?.replace("X",props?.shareholderData?.getAllData?.noofapartments)}</th>
                        <th className="cu-width-20p text-right fw-600">{props.TranslateString("num_of_apartments_pdf")}</th>
                        <th className="cu-width-30p text-right fw-600">{props.TranslateString("the_percentage_of_the_shares_owned_of_hc")}</th>
                    </tr>
                </thead>
                <tbody className="bg-light">
                    <tr>
                        <td>{props.TranslateString("Yksityisomistuksessa— asuu huoneistossa (People-owned, lives in HC)")} </td>
                        <td className="text-right ">{props?.data?.personownedandlivedin?.numberofspaces || 0}</td>
                        <td className="text-right">{props?.data?.personownedandlivedin?.percentageoftotalshares || "0 %"}</td>
                    </tr>
                    <tr>
                        <td>{props.TranslateString("Yksityisomistuksessa— asuu muualla (People-owned, lives elsewhere)")} </td>
                        <td className="text-right">{props?.data?.personownedandnonlivedin?.numberofspaces || 0}</td>
                        <td className="text-right">{props?.data?.personownedandnonlivedin?.percentageoftotalshares || "0 %"}</td>
                    </tr>
                    <tr>
                        <td>{props.TranslateString("Yritysten omistuksessa (Company-owned)")}</td>
                        <td className="text-right">{props?.data?.companyowned?.numberofspaces || 0}</td>
                        <td className="text-right">{props?.data?.companyowned?.percentageoftotalshares || "0 %"}</td>
                    </tr>
                </tbody>
            </table>
        </>
    );
}

export default PDFPage8Table1;